/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/DeliverySystemCard.js
 */

import React from 'react';
import { resultToRendererMap } from '../search/ResultsArea';

const getDeliverySystemLink = (data) =>
  `/search?query=${data.deliverySystem}:${data.id}`;

const DeliverySystemCard = ({ data, type, auth }) => {
  const deliverySystemCardSubType = `${data.deliverySystem}Card`;

  const component = resultToRendererMap[deliverySystemCardSubType];
  let card;
  if (component == null) {
    card = null;
  } else {
    card = React.createElement(
      component,
      {
        data: data,
        type: deliverySystemCardSubType,
        auth: auth,
      },
      null
    );
  }
  return <div className="Section">{card}</div>;
};

export { getDeliverySystemLink };
export default DeliverySystemCard;
